import { replace } from 'ramda'

const s3LinkParser = replace(
  's3.us-east-1.amazonaws.com/livdemybucket',
  'livdemybucket.s3.amazonaws.com',
)

export default s3LinkParser
